// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"4dff56db","464":"7e648171","678":"f12d53ef","978":"f7513f01"}[chunkId] + ".chunk.js";
};